import React, { useState, useEffect } from 'react'
import { getHistoryTagBrand } from '../../../services/api/apiBrands'
import { message } from 'antd'
import HistoryItem from './HistoryItem'

function TagBrandHistories(props) {
    const { idTagBrand, loading } = props
    const [historyData, setHistoryData] = useState([])
    const [limit, _setLimit] = useState(10000)
    const [page, _setPage] = useState(1)

    const fetchData = async () => {
        const payload = { page: page, limit: limit }
        try {
            const { data: res } = await getHistoryTagBrand(idTagBrand, payload)
            const { success, message: mess, data } = res || {}
            if (!success) {
                throw new Error(mess)
            }
            setHistoryData(data)
        } catch (error) {
            message.error(error.message)
        }
    }

    useEffect(() => {
        if (idTagBrand) fetchData()
    }, [idTagBrand, loading])

    return (Array.isArray(historyData) && historyData.length > 0 &&
        <div className="TagBrandHistories SectionInner card mt-3" style={{ fontSize: 15 }}>
            <div className='p-4 h-100' >
                <h3 className='font-weight-bold'>History</h3>
                {Array.isArray(historyData) && historyData.length > 0 && historyData.map((i, idx) => (
                    <HistoryItem
                        className="TagBrandHistoriesItem"
                        key={`TagBrandHistoriesItem_${idx}`}
                        item={i}
                    />
                ))}
            </div>
        </div>
    )
}

export default TagBrandHistories